import { formatImage, formatUrl } from 'ThreeTerminal_base/publicMethod';

// 处理专题预览数据
export const handleTopicPreviewData = (topicPreviewData, isShare, isVivo) => {
    let moduleIndex = 1;
    let showModuleNum = 0;
    let showCommentModule = false;
    const vivoUrl = 'https://h5.ifeng.com/c/vivoPage';
    const v2 = topicPreviewData.dataVersion === 'v2';

    // 特殊链接处理
    const fixSpecialCase = (artic, url, isShare) => {
        if (
            (/house\.ifeng\.com/.test(url) || /https:\/\/zhuanti\.ishare\.ifeng\.com/.test(url)) &&
            isShare &&
            artic.type !== 'web'
        ) {
            return `https://ishare.ifeng.com/c/s/${artic.base62Id}`;
        }

        return url;
    };

    // vivo 合作页链接处理
    const fillVivoUrl = (artic, url) => {
        if (!isVivo) {
            if (!url) {
                return '';
            }

            return url.includes('?') ? url : `${url}?`;
        }

        let result = '';

        switch (artic.type) {
            case 'video':
            case 'miniVideo':
                result = `${vivoUrl}/${artic.guid.replace('ucms_', '')}?ch=ref_vivo_fyp1`;
                break;
            case 'slide':
                result = `${vivoUrl}/${artic.base62Id}?ch=ref_vivo_fyp1`;
                break;
            case 'web':
            case 'special':
                result = artic.url.replace(/\/special\//, '/vivo/');
                break;
            default:
                result = `${vivoUrl}/${artic.base62Id}?ch=ref_vivo_fyp1`;
        }

        if (artic.wapUrl) {
            artic.wapUrl = artic.wwwUrl = artic.wapUrl.replace(
                'izhibo.ifeng.com/live.html',
                'izhibo.ifeng.com/live_vivo.html',
            );
        }

        return result;
    };

    if (!topicPreviewData.ad) {
        topicPreviewData.adData = {};
    } else {
        topicPreviewData.adData =
            topicPreviewData.ad && typeof topicPreviewData.ad === 'object'
                ? topicPreviewData.ad
                : JSON.parse(topicPreviewData.ad);
    }

    if (topicPreviewData.modules) {
        const newModules = [];

        topicPreviewData.modules.forEach(modu => {
            if (modu.type === 'comment') {
                // vivo合作页不展示评论，其他类型页必须展示评论
                if (isVivo) modu.display = false;
                else modu.display = 1;
            }

            if (v2) {
                if (modu.type === 'flow') {
                    modu.type = 'column';
                    modu.data = [Object.assign(modu, modu.data)];
                }
            }

            if (modu.display) showModuleNum++;
            if (modu.display && modu.type === 'comment') showCommentModule = true;

            if (modu.type === 'slide') {
                if (v2) {
                    modu.data = modu.data.articleList;
                }

                modu.data.forEach(item => {
                    if (item.thumbnails?.image) item.thumbnails = item.thumbnails.image;
                    if (item.thumbnails && item.thumbnails.length)
                        item.thumbnail = formatImage(item.thumbnails[item.thumbnails.length - 1].url, 690, 350);

                    item.url = `${fillVivoUrl(item, item.url)}&srctag=exp_national_slide_${0}`;
                });

                return (topicPreviewData.slideData = modu);
            }

            if (modu.data?.length) {
                modu.data = modu.data.map((item, itemIndex) => {
                    // Newstream 数据结构
                    if (item.articleList) {
                        if (modu.display) {
                            item.moduleIndex = moduleIndex++;
                        }

                        const _articleList = [];

                        item.articleList.forEach((artic, index) => {
                            if (!isVivo && !isShare && artic.status === 8) {
                                return;
                            }

                            let url = isShare && artic.clientUrl ? artic.clientUrl : artic.url;

                            url = fixSpecialCase(artic, url, isShare);
                            url = fillVivoUrl(artic, url);

                            if (isVivo) url += `&srctag=exp_national_${itemIndex}_${index}`;

                            // fix ssr bug
                            const _thumbnails = (artic.thumbnails && artic.thumbnails.image) || artic.thumbnails;

                            _articleList.push({
                                ...artic,
                                hasVideoIcon:
                                    (artic.newStyle === 'titleimg' || artic.clientStyle === 'titleimg') &&
                                    artic.type === 'video',
                                thumbnail: artic.thumbnail,
                                thumbnails: { image: _thumbnails || [] },
                                id: artic.id ? artic.id : index,
                                url,
                                newStyle: artic.newStyle || artic.clientStyle,
                                // FIXME: 与手凤拉起提示冲突
                                // callUp: !isShare && !isVivo ? 1 : null,
                                source: artic.source || artic.ESsourceAlias,
                                commentUrl: artic.commentUrl || `ucms_${artic.base62Id}`,
                            });
                        });

                        item.articleList = _articleList.slice();

                        // 塞入广告
                        // if (
                        //     topicPreviewData.adData.infoFourthAd &&
                        //     topicPreviewData.adData.infoFourthAd.data &&
                        //     itemIndex === 0
                        // ) {
                        //     item.articleList.splice(3, 1, {
                        //         ...topicPreviewData.adData.infoFourthAd.data,
                        //         thumbnails: {
                        //             image: topicPreviewData.adData.infoFourthAd.data.img.map(img => ({
                        //                 url: img,
                        //             })),
                        //         },
                        //         source: '广告',
                        //     });
                        // }
                    }

                    if (item.info) {
                        if (item.info.type !== 'web' && isShare) {
                            item.link = item.info.clientUrl;
                        } else if (isVivo) {
                            item.link = `${vivoUrl}&type=doc&aid=ucms_${item.info.base62Id}`;
                        } else {
                            item.link = item.info.url;
                        }
                    }

                    if (modu.type === 'slide' && isVivo) {
                        item.url = `${fillVivoUrl(item, item.url)}&srctag=exp_national_slide_${itemIndex}`;
                    }

                    return {
                        ...item,
                        title: modu.type !== 'slide' ? item.info && item.info.title : item.title,
                    };
                });
            }

            // 话题id
            if (modu.type === 'comment' && modu.display) {
                modu.moduleIndex = moduleIndex;
                topicPreviewData.talkId = modu.data[0] && modu.data[0].talkId;
            }

            if (!~['column', 'slide'].indexOf(modu.type) && modu.display && modu.data.length) {
                modu.moduleIndex = moduleIndex++;
            }

            if (!~['supply'].indexOf(modu.type)) newModules.push(modu);
        });
        topicPreviewData.modules = newModules;
    }

    // topicPreviewData.bannerImg = formatImage(topicPreviewData.bannerImg, 750, 550);
    // topicPreviewData.bannerAdImg = formatImage(topicPreviewData.bannerAdImg, 750, 550);
    // topicPreviewData.newBannerImg = formatImage(topicPreviewData.newBannerImg, 750, 232);

    topicPreviewData.showModuleNum = showModuleNum;
    topicPreviewData.showCommentModule = showCommentModule;

    return topicPreviewData;
};

// 获取地址栏参数
export const getUrlParams = () => {
    const result = {};
    const params = window.location.search.substring(1).split('&');
    let param = [];

    for (let i = 0, iLen = params.length; i < iLen; i++) {
        param = params[i].split('=');
        if (param.length === 2) {
            result[param[0]] = decodeURIComponent(param[1]);
        }
    }

    return result;
};
